import { isExists } from 'date-fns';

export const MAX_YEARS = 120;

const EARLIEST_YEAR = 1900;
const LATEST_YEAR = 2100;

export const isSupportedYears = (value: number) =>
  value >= 0 && value <= MAX_YEARS;

export const isSupportedCalendarDate = (value: string) => {
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return false;

  const [year, month, day] = match.slice(1).map(Number);
  return (
    year >= EARLIEST_YEAR &&
    year <= LATEST_YEAR &&
    isExists(year, month - 1, day)
  );
};
